import React, { useEffect, useState } from "react";
import { useLoad, useDebounced, PageHead, Card, Search, Pager, Skeleton, Empty, ErrorBox, Badge, fdt, ago } from "../ui";

const TAKE = 60;
const TONE = { delete: "red", block: "amber", approve: "green", reject: "red", create: "cyan", update: "blue", send: "violet", grant: "green", settings: "violet" };
const tone = (a) => {
  const k = Object.keys(TONE).find((x) => a.includes(x));
  return k ? TONE[k] : "gray";
};

export default function ActivityLog() {
  const [q, setQ] = useState("");
  const [skip, setSkip] = useState(0);
  const dq = useDebounced(q);
  useEffect(() => setSkip(0), [dq]);
  const { data, loading, error, reload } = useLoad("logs", { q: dq, take: TAKE, skip }, [dq, skip]);
  const items = (data && data.items) || [];
  return (
    <div>
      <PageHead icon="fa-solid fa-clock-rotate-left" title="Activity Log" subtitle="Admin panel से website पर किए गए हर बदलाव का रिकॉर्ड" />
      <Search value={q} onChange={setQ} placeholder="जैसे: delete, payment, settings…" className="mb-4 max-w-md" />
      <ErrorBox msg={error} retry={reload} />
      <Card pad={false}>
        {loading && !data ? <div className="p-4"><Skeleton rows={8} /></div> : !items.length ? <Empty icon="fa-solid fa-clock-rotate-left" title="अभी कोई activity नहीं" /> : (
          <ul>
            {items.map((l) => {
              let d = null;
              try {
                d = l.detail ? JSON.parse(l.detail) : null;
              } catch (e) {
                d = l.detail;
              }
              return (
                <li key={l.id} className="flex flex-wrap items-start gap-3 px-5 py-3 border-b wa-line last:border-0">
                  <Badge tone={tone(l.action)} className="mt-0.5">{l.action}</Badge>
                  <div className="flex-1 min-w-[200px]">
                    {l.target && <p className="text-sm font-semibold break-all">{l.target.length > 120 ? l.target.slice(0, 120) + "…" : l.target}</p>}
                    {d && <p className="text-[12px] wa-muted break-all">{typeof d === "string" ? d : Object.entries(d).map(([k, v]) => `${k}: ${typeof v === "object" ? JSON.stringify(v) : v}`).join(" · ").slice(0, 300)}</p>}
                  </div>
                  <span className="text-[12px] wa-muted whitespace-nowrap" title={fdt(l.createdAt)}>{ago(l.createdAt)}</span>
                </li>
              );
            })}
          </ul>
        )}
        <Pager total={data && data.total} take={TAKE} skip={skip} onChange={setSkip} />
      </Card>
    </div>
  );
}
